import {
  APP_INITIALIZER,
  CUSTOM_ELEMENTS_SCHEMA,
  NgModule,
  Optional,
} from '@angular/core';
import { of } from 'rxjs';
import { BrowserModule } from '@angular/platform-browser';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';

import {
  TemplateRegistry,
  ItemModel,
  RouterConfigService,
} from '@backbase/foundation-ang/core';
import { authConfig, environment } from 'src/environments/environment';
import { ActivatedRoute, RouterModule } from '@angular/router';

import {
  PUBSUB,
  PubSubService,
  WebSdkApiModule,
  WebSdkModule,
} from '@backbase/foundation-ang/web-sdk';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import {
  BrowserAnimationsModule,
  NoopAnimationsModule,
} from '@angular/platform-browser/animations';
import { LegacyRouterService } from './utils/legacy-router-service';

//Autenticacion
import { AuthModule } from './src/auth.module';
import { IdentityAuthModule } from '@backbase/identity-auth';
import { BnUserContextMenuWidgetExtendedService } from './utils/user-context-menu-widget-extended.service';
import { AccessgroupDataHttpService } from '@backbase/accessgroup-data-http-ang';
import {
  HTTP_INTERCEPTORS,
  HttpClientModule,
  HttpClientXsrfModule,
} from '@angular/common/http';

import { AppDataModule } from './app-data.module';

function journeyItemModelFactory(route) {
  return route.snapshot.data.item;
}

//API
import {
  AccessControlApiModule,
  AccessControlConfiguration,
} from '@backbase/accesscontrol-http-ang';
import { CataloguesHttpService } from 'banesco-catalogues-api';
import { AccessgroupDataHttpModule } from '@backbase/accessgroup-data-http-ang';
import { TransactionSigningWidgetExtendedModule } from './src/transaction-signing-widget-extended/src/transaction-signing-widget-extended.module';

//Menu
import { BnTransactionSigningModule } from './src/identity-core-ang/src/transaction-signing/transaction-signing.module';
import { TransactionSigningIdentityInterceptor } from './utils/transaction-signing-identity-interceptor';
import { InitUserContextService } from './utils/InitUserContext.service';
import { LanguageInterceptorService } from './utils/languaje-interceptor';
import { AuthInterceptor } from './src/auth.interceptor';
import { ModifyBodyContactsInterceptor } from './utils/modify-body-contacts.service';
import { RedirectToOnboardingInterceptorService } from './interceptors/redirect-to-onboarding-interceptor.service';
import { RemoteConfigService } from './views/components/ui-components/src/bn-marketing-carousel/firebase-remote-config.service';
import { EventLoginInterceptor } from './interceptors/eventLogin.interceptor.service';
import { FeatureFlagsService } from './utils/feature-flags.service';

const widgetProperties: { [key: string]: any } = {
  placement: 'top-right',
};
const itemModelStub = {
  properties: of({}),
  property: (key: string) => of(widgetProperties[key]),
};

export function initializeApp1(appInitService: InitUserContextService) {
  return (): Promise<any> => {
    return appInitService.Init();
  };
}

export function remoteConfigInitializer(
  remoteConfigService: RemoteConfigService
) {
  const currentKey = `web_marketing_${remoteConfigService.envName}`;
  return () => remoteConfigService.fetchAndGetValue(currentKey).catch(() => {});
}

export function featureFlagsInitializer(
  featureFlagsService: FeatureFlagsService
) {
  return () => featureFlagsService.getFlags().catch(() => {});
}

const accessControlConfiguration = () =>
  new AccessControlConfiguration({ basePath: '/api/access-control' });

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    HttpClientXsrfModule,

    environment.animation ? BrowserAnimationsModule : NoopAnimationsModule,

    IdentityAuthModule,
    AuthModule.forRoot(environment.apiRoot, authConfig),
    WebSdkModule.forRoot(environment.webSdkConfig),

    StoreModule.forRoot({}),
    EffectsModule.forRoot([]),

    BnTransactionSigningModule.withConfig(),
    TransactionSigningWidgetExtendedModule,

    AppDataModule,

    AccessgroupDataHttpModule.forRoot({
      servicePath: location.origin + '/api/access-control',
      apiRoot: '',
    }),
    AccessControlApiModule.forRoot(accessControlConfiguration),
  ],
  providers: [
    // ...(environment.mockProviders || []),
    AccessgroupDataHttpService,
    TemplateRegistry,
    // { provide: APP_INITIALIZER,useFactory: initializeApp1, deps: [InitUserContextService], multi: true},
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ModifyBodyContactsInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: LanguageInterceptorService,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TransactionSigningIdentityInterceptor,
      multi: true,
    },
    {
      provide: PUBSUB,
      useExisting: PubSubService,
    },
    {
      provide: ItemModel,
      useValue: itemModelStub,
    },
    {
      provide: RouterConfigService,
      useClass: LegacyRouterService,
    },
    {
      provide: ItemModel,
      useFactory: journeyItemModelFactory,
      deps: [ActivatedRoute],
    },
    // {
    //   provide: HTTP_INTERCEPTORS,
    //   useClass: RedirectToOnboardingInterceptorService,
    //   multi: true,
    // },
    RemoteConfigService,
    {
      provide: APP_INITIALIZER,
      useFactory: remoteConfigInitializer,
      deps: [RemoteConfigService],
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: EventLoginInterceptor,
      multi: true,
    },
    FeatureFlagsService,
    {
      provide: APP_INITIALIZER,
      useFactory: featureFlagsInitializer,
      deps: [FeatureFlagsService],
      multi: true,
    },
    CataloguesHttpService,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  bootstrap: [AppComponent],
})
export class AppModule {}
